skrilla.controller('settleMarketModalCtrl', function ($scope, searchService, modalService, cacheService) {
    const market = cacheService.getObjectOrElse("bettingMarketDetails", function () {
        modalService.dismissAll()
    });
    $scope.market = market.market;
    $scope.outcomes = market.outcomes
    $scope.sortedOutcomes =  Array.from(Object.entries($scope.outcomes), ([id, value]) => ({id, value}))
            .sort((a, b) => {
                if (a.value.attributes?.runnerNumber && b.value.attributes?.runnerNumber) {
                    return parseInt(a.value.attributes.runnerNumber) - parseInt(b.value.attributes.runnerNumber)
                } else return 0
            }).map(outcome => outcome.id)
    $scope.outcomeResults = [
        "WIN",
        "LOSE",
        "UNDECIDED",
        "VOID"
    ]
    $scope.message = ""
    $scope.spOutcomeOdds = null
    $scope.overrideDeadHeatTotal = false
    $scope.interimSettlement = false


    $scope.isInvalid = function () {
        if (!$scope.message || !$scope.message.trim()) {
            return true;
        }
        for (const id in $scope.outcomes) {
            let outcome = $scope.outcomes[id]
            if (outcome.result === "UNDECIDED" && !$scope.interimSettlement) {
                return true;
            }
            if (outcome.result === "WIN" && outcome.odds === 1.00) {
                return true;
            }
        }
        return false;
    }

    $scope.setDeadHeatTotal = function () {
        let total = Object.values($scope.outcomes || []).filter((it) => it.result === 'WIN').map((it) => it.deadHeatFactor || 0).reduce((a, b) => a + b, 0.0);
        $scope.deadHeatTotal = total;
    }
    $scope.calculateDeadHeatFactors = function () {
        let winCount = Object.values($scope.outcomes || []).filter((it) => it.result === 'WIN').length;
        let factor = null;
        if (winCount > 1) {
            factor = Number.parseFloat((1.0 / winCount).toFixed(4));
        }
        Object.values($scope.outcomes || []).forEach((it) => {
            if (it.result === "WIN") {
                it.deadHeatFactor = factor;
            } else {
                it.deadHeatFactor = null;
            }

        })
        $scope.setDeadHeatTotal()
        if ($scope.deadHeatTotal === 0.9999) {
            const first = Object.values($scope.outcomes || []).find((it) => it.result === 'WIN')
            if (first) {
                first.deadHeatFactor = first.deadHeatFactor + 0.0001;
            }
        }
    }

    $scope.setSpOdds = function (outcomeId, newOdds) {
        if ($scope.oddsNotValid(newOdds)) {
            modalService.error("Odds must be set to greater than 1.00 and have no more than 2 decimal places")
        } else {
            modalService.confirm(`Are you sure you'd like to set the odds for ${$scope.outcomes[outcomeId].name} to ${newOdds}?`,
                function () {
                    $scope.outcomes[outcomeId].spOddsUpdate = newOdds
                    $scope.outcomes[outcomeId].odds = newOdds
                    $scope.$apply()
                })
        }
    }

    $scope.oddsNotValid = function (odds, result) {
        return ( !odds || odds <= 1.00 || $scope.countDecimals(odds) > 2);
    }

    $scope.countDecimals = function (number) {
        if (Math.floor(number) === number) return 0;
        return number.toString().split(".")[1].length || 0;
    }

    $scope.settle = function () {

        var outcomeResults = [];

        var outcomes = $scope.outcomes;
        for (var id in outcomes) {
            outcomeResults.push({
                ...(outcomes[id]),
                id: id,
            });
        }
        $scope.setDeadHeatTotal();
        if ($scope.deadHeatTotal !== 0.0 && $scope.deadHeatTotal !== 1.0 && !$scope.overrideDeadHeatTotal) {
            //todo: Do this better in v2
            alert("Dead heat factors must equal 0 or 1. Currently: " + $scope.deadHeatTotal)
            return
        }

        modalService.confirm("Are you sure you'd like to settle this " + $scope.market.status + " market?", function () {
            searchService.put("betting/markets/" + $scope.market.id + "/settle", {
                outcomeResults,
                message: $scope.message
            }, "Market successfully settled").then(function (response) {
                modalService.dismissAll();
            });
        });
    }
    $scope.winner = function (outcomeId) {
        var outcomes = $scope.outcomes;
        for (var id in outcomes) {
            var outcome = outcomes[id]
            if (id == outcomeId) {
                outcome.result = 'WIN'
            } else {
                outcome.result = 'LOSE'
            }
        }
    }
    $scope.voidOutcomes = function () {
        Object.values($scope.outcomes).forEach(outcome => outcome.result = 'VOID')
    }

});
